import api from './client';

export interface AutoFixAction {
  id: number;
  fix_type: string;
  fix_type_label: string;
  resource_type: 'product' | 'page';
  shopify_product_id: number | null;
  shopify_page_id: number | null;
  product_title: string;
  old_value: string | null;
  new_value: string;
  status: 'pending' | 'applied' | 'failed' | 'skipped';
  is_applied: boolean;
  error_message: string | null;
  applied_at: string | null;
}

export interface AutoFixRun {
  id: number;
  store_audit_run_id: number | null;
  status: 'ready' | 'applying' | 'completed' | 'failed';
  status_label: string;
  is_ready: boolean;
  planned_count: number;
  applied_count: number;
  failed_count: number;
  ai_model: string | null;
  cost_usd: number;
  applied_at: string | null;
  created_at: string | null;
  actions?: AutoFixAction[];
}

export const autoFixApi = {
  list: (page = 1) =>
    api.get<{ data: AutoFixRun[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/auto-fix?page=${page}`
    ),

  plan: () => api.post<{ data: AutoFixRun }>('/auto-fix'),

  apply: (id: number) => api.post<{ data: AutoFixRun }>(`/auto-fix/${id}/apply`),

  show: (id: number) => api.get<{ data: AutoFixRun }>(`/auto-fix/${id}`),

  destroy: (id: number) => api.delete(`/auto-fix/${id}`),
};
